import { Record, List } from 'immutable';
import { PREVIEW_PAGES } from 'knowledge-content-ui/constants/TemplateEditorConstants';

// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
const EMPTY_LIST = new List();
const TemplateEditorNavigationContext = Record({
  navItemLabels: EMPTY_LIST,
  navItems: EMPTY_LIST,
  previewPage: PREVIEW_PAGES.HOME_PAGE,
  selectedLanguage: null,
  selectedNavItem: {
    type: undefined,
    itemValue: undefined
  }
});
export default TemplateEditorNavigationContext;